import _ from "lodash";

export const formatDateAndTime = (timestamp) => {
  if (timestamp) {
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedDateAndTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateAndTime;
  } else {
    return "-";
  }
};
export const getImageUrl = (image) => {
  const img = Array.isArray(image) ? image[0] : image;
  if (!img) return "images/product/no-image.png";
  return img.startsWith("http")
    ? img
    : `${process.env.REACT_APP_API_BASE_URL}${img}`;
};
export const convertCartsToCartItems = (carts, products_grouping) => {
  const cartItems = [];

  if (!Array.isArray(carts)) {
    console.warn("Carts is not an array:", carts);
    return cartItems;
  }

  if (products_grouping) {
    // Use a map to group products by productId
    const productMap = new Map();

    carts.forEach((cart) => {
      if (cart.produits && Array.isArray(cart.produits)) {
        cart.produits.forEach((produit) => {
          if (produit.product) {
            const productId = produit.product._id;

            if (productMap.has(productId)) {
              // Increment quantity and netPrice
              const existing = productMap.get(productId);
              existing.quantity += produit.quantity;
              existing.netPrice += produit.netPrice;
            } else {
              productMap.set(productId, {
                id: productId,
                productId: productId,
                cartIds: [cart._id],
                quantity: produit.quantity,
                price: produit.price,
                productInfo: { ...produit.product },
                netPrice: produit.netPrice,
                originalCartData: produit,
                ingredients: produit.ingredients,
              });
            }
          }
        });
      }
    });

    // Convert map to array
    cartItems.push(...Array.from(productMap.values()));
  } else {
    // No grouping, just flatten all cart items
    carts.forEach((cart) => {
      if (cart.produits && Array.isArray(cart.produits)) {
        cart.produits.forEach((produit) => {
          if (produit.product) {
            console.log("cart", cart);
            const uniqueId = `${cart.code}-${produit.product._id}`;
            cartItems.push({
              id: uniqueId,
              productId: produit.product._id,
              cartId: cart._id,
              quantity: produit.quantity,
              price: produit.price,
              productInfo: { ...produit.product },
              netPrice: produit.netPrice,
              originalCartData: produit,
              ingredients: produit.ingredients,
            });
          }
        });
      }
    });
  }

  return cartItems;
};

// Normalizes the various shapes passed to callImpression(dataTicket, type)
// into the `cart` shape OrderDetailsModal expects, for the on-screen
// fallback when "impressionTicket" is turned off in parametrage caisse.
export const buildReceiptCart = (dataTicket, type) => {
  const asProduits = (items) =>
    (items || []).map(
      (item) =>
        item.originalCartData || {
          product: item.productInfo,
          quantity: item.quantity,
          price: item.price,
          totalPrice: (item.price || 0) * (item.quantity || 0),
          remise: item.remise || 0,
          netPrice: item.netPrice,
        },
    );

  if (type === "addition") {
    // dataTicket: { session, items, table, timbre }
    return {
      produits: asProduits(dataTicket.items),
      session: dataTicket.session,
      tableNumber:
        dataTicket.table?.table_number || dataTicket.table?.numero,
      code: dataTicket.session?.code,
      createdAt: dataTicket.session?.createdAt,
    };
  }

  if (type === "payment") {
    // dataTicket: { session/table_session, carts, payments, table, total, ... }
    const session = dataTicket.table_session || dataTicket.session;
    return {
      produits: asProduits(dataTicket.carts),
      session,
      payments: dataTicket.payments,
      tableNumber:
        dataTicket.table?.table_number || dataTicket.table?.numero,
      code: session?.code,
      createdAt: session?.createdAt,
      prix: dataTicket.total,
    };
  }

  // "produits" (new order ticket) — dataTicket is already close to a raw
  // cart document, just ensure `session` is attached if passed alongside.
  return { ...dataTicket };
};

export const calculateReceiptByTVA = (items) => {
  const tvaMap = new Map();

  items.forEach((item) => {
    if (!item.productInfo) return;

    const prixHT = Number(item.productInfo.prix_ht || 0);
    const quantity = Number(item.quantity || 0);
    const remise = Number(item.remise || 0);
    const tauxTVA = Number(item.productInfo.tva || 19);

    const totalHT = prixHT * quantity;
    const remiseValue = totalHT * (remise / 100);
    const netHT = totalHT - remiseValue;

    if (!tvaMap.has(tauxTVA)) {
      tvaMap.set(tauxTVA, {
        tauxTVA,
        baseHT: 0,
      });
    }

    tvaMap.get(tauxTVA).baseHT += netHT;
  });

  return Array.from(tvaMap.values()).map(({ tauxTVA, baseHT }) => {
    const montantTVA = baseHT * (tauxTVA / 100);
    const totalTTC = baseHT + montantTVA;

    return {
      tauxTVA,
      baseHT: Number(baseHT.toFixed(3)),
      montantTVA: Number(montantTVA.toFixed(3)),
      totalTTC: Number(totalTTC.toFixed(3)),
    };
  });
};

export const formatTime = ({ date }) => {
  const options = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return new Date(date).toLocaleTimeString(undefined, options);
};

export const formadate = (date) => {
  if (date) {
    const inputDate = new Date(date);
    const day = inputDate.getDate().toString().padStart(2, "0");
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const year = inputDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  } else {
    return "";
  }
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatdate = (date) => {
  const inputDate = new Date(date);
  const day = inputDate.getDate().toString().padStart(2, "0");
  const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
  const year = inputDate.getFullYear();
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

const addBarcode = (orderNumber) => {
  const codeData = "{B" + orderNumber;
  const bytes = [0x1d, 0x6b, 73, codeData.length];
  for (let i = 0; i < codeData.length; i++) {
    bytes.push(codeData.charCodeAt(i));
  }
  bytes.push(0x00);
  return new Uint8Array(bytes);
};

export const ImpressionTicket = (typeTicket, data) => {
  if (!data) return [];

  const restaurant = JSON.parse(localStorage.getItem("organisations"))[0];

  const ESC = "\x1B";
  const ESC_POS_COMMANDS = {
    INITIALIZE: ESC + "@",
    CENTER: ESC + "\x61\x01",
    LEFT_ALIGN: ESC + "\x61\x00",
    BOLD_ON: ESC + "\x45\x01",
    BOLD_OFF: ESC + "\x45\x00",
    DOUBLE_HEIGHT: ESC + "\x21\x30",
    NORMAL_TEXT: ESC + "\x21\x00",
    CUT_PAPER: "\x1D\x56\x00",
  };

  // Helper to add a line with newline
  const println = (lines, text = "") => {
    lines.push(text + "\n");
  };

  const generateHeader = (lines, title) => {
    const currentDate = new Date();

    lines.push(ESC_POS_COMMANDS.CENTER);
    lines.push(ESC_POS_COMMANDS.DOUBLE_HEIGHT);
    println(lines, ` ${title} `);

    println(lines, restaurant.nom);
    println(lines, restaurant.address);
    println(lines, restaurant.numero);
    lines.push(ESC_POS_COMMANDS.NORMAL_TEXT);
    lines.push(ESC_POS_COMMANDS.LEFT_ALIGN);

    println(
      lines,
      `Date: ${formadate(currentDate)} ${formatTime({ date: currentDate })}`,
    );

    return lines;
  };

  const generateFooter = (lines) => {
    lines.push(ESC_POS_COMMANDS.CENTER);
    println(lines, "-----------------------------");
    println(lines, "Merci de votre visite !");
    println(lines, "\n\n");
    lines.push(ESC_POS_COMMANDS.CUT_PAPER);
    return lines;
  };

  const addSeparator = (lines) => {
    println(lines, "-".repeat(48));
    return lines;
  };

  switch (typeTicket) {
    case "produits": {
      const lines = [];
      // generateHeader(lines, `N° ${data.numero}`);
      lines.push(ESC_POS_COMMANDS.CENTER);
      lines.push(ESC_POS_COMMANDS.DOUBLE_HEIGHT);
      println(lines, `Ticket : ${data.numero}`);
      lines.push(ESC_POS_COMMANDS.NORMAL_TEXT);
      lines.push(ESC_POS_COMMANDS.LEFT_ALIGN);

      println(
        lines,
        `Table: ${data.table_id.table_number === "0" ? "Comptoir" : data.table_id.table_number} Date: ${formadate(
          data.table_session.start_time,
        )} ${formatTime({ date: data.table_session.start_time })}`,
      );

      if (data.table_session.caissier_id && data.table_session.serveur_id) {
        println(
          lines,
          `Caissier: ${data.table_session.caissier_id?.nom}  Serveur: ${data.table_session.serveur_id?.nom}`,
        );
      } else if (data.table_session.caissier_id?.nom) {
        println(lines, `Caissier: ${data.table_session.caissier_id?.nom}`);
      } else {
        println(lines, `Serveur: ${data.table_session.serveur_id?.nom}`);
      }

      addSeparator(lines);

      if (data.produits && Array.isArray(data.produits)) {
        data.produits.forEach((produit) => {
          const productName = produit.product?.titre?.fr || "Produit sans nom";
          const quantity = produit.quantity || 1;

          println(lines, `x${quantity} ${productName}`);

          if (produit.ingredients?.length > 0) {
            produit.ingredients.forEach((ingredient) => {
              println(lines, `  + ${ingredient.titre || "Ingrédient"}`);
            });
          }
        });
      } else {
        println(lines, "Aucun produit");
      }
      println(lines, "\n\n\n");
      lines.push(ESC_POS_COMMANDS.CUT_PAPER);
      // generateFooter(lines);
      return lines.join("");
    }

    case "payment": {
      const lines = [];
      const LINE_WIDTH = 48;

      const padRight = (text, width) =>
        text.length >= width
          ? text.slice(0, width)
          : text + " ".repeat(width - text.length);
      const padLeft = (text, width) =>
        text.length >= width
          ? text.slice(0, width)
          : " ".repeat(width - text.length) + text;
      const formatLine = (left, right) =>
        padRight(left, LINE_WIDTH - right.length) + right;

      // Header
      lines.push(ESC_POS_COMMANDS.CENTER);
      lines.push(ESC_POS_COMMANDS.BOLD_ON);
      println(lines, restaurant.nom);
      println(lines, restaurant.address);
      println(lines, `Tel: ${restaurant.numero}`);
      lines.push(ESC_POS_COMMANDS.BOLD_OFF);

      lines.push(ESC_POS_COMMANDS.LEFT_ALIGN);
      println(
        lines,
        `Table: ${data.table.table_number === "0" ? "Comptoir" : data.table.table_number} Date: ${formadate(
          data.table_session.start_time,
        )} ${formatTime({ date: data.table_session.start_time })}`,
      );

      if (data.caissier && data.serveur) {
        println(
          lines,
          `Caissier: ${data.caissier.nom}  Serveur: ${data.serveur.nom}`,
        );
      } else if (data.caissier.nom) {
        println(lines, `Caissier: ${data.caissier.nom}`);
      } else {
        println(lines, `Serveur: ${data.serveur.nom}`);
      }

      addSeparator(lines);

      // Products
      const produits = data.carts;
      console.log(produits);
      if (produits && Array.isArray(produits)) {
        produits.forEach((produit) => {
          const name =
            produit.productInfo?.titre?.fr ||
            produit.product?.titre?.fr ||
            "Produit sans nom";
          const qty = produit.quantity || 1;
          const price = produit.price || 0;
          const total = (
            qty *
            (price / produit.productInfo.prix_quantite)
          ).toFixed(3);

          println(lines, padRight(name, LINE_WIDTH));
          println(
            lines,
            formatLine(`  ${qty} x ${price.toFixed(3)} `, `${total}`),
          );

          // Ingredients (optional)
          if (produit.ingredients?.length > 0) {
            produit.ingredients.forEach((ingredient) => {
              // println(lines, `  + ${ingredient.titre || "Ingrédient"}`);
              println(
                lines,
                formatLine(
                  `  + ${ingredient.titre || "Ingrédient"}`,
                  `   ${ingredient.prix.toFixed(3) || ""} `,
                ),
              );
            });
          }
        });
      } else {
        println(lines, "Aucun produit");
      }
      if (data.timbre > 0)
        println(
          lines,
          formatLine("Timbre", `${parseFloat(data.timbre).toFixed(3)}`),
        );
      addSeparator(lines);
      console.log("data.HT", data.HT);
      // Total

      if (data.total) {
        lines.push(ESC_POS_COMMANDS.BOLD_ON);
        println(
          lines,
          formatLine("TOTAL TTC", `${parseFloat(data.total).toFixed(3)}`),
        );
        lines.push(ESC_POS_COMMANDS.BOLD_OFF);
      }
      if (data.acompte) {
        lines.push(ESC_POS_COMMANDS.BOLD_ON);
        println(
          lines,
          formatLine("ACOMPTE", `${parseFloat(data.acompte).toFixed(3)}`),
        );
        lines.push(ESC_POS_COMMANDS.BOLD_OFF);
      }
      if (data.total && data.acompte) {
        lines.push(ESC_POS_COMMANDS.BOLD_ON);
        println(
          lines,
          formatLine(
            "TOTAL TTC A PAYER",
            `${parseFloat(data.total - data.acompte).toFixed(3)}`,
          ),
        );
        lines.push(ESC_POS_COMMANDS.BOLD_OFF);
      }
      addSeparator(lines);
      data.HT.forEach((element) => {
        println(
          lines,
          `TVA ${element.tauxTVA} - Base HT: ${element.baseHT} - Montant : ${element.montantTVA}`,
        );
        addSeparator(lines);
      });

      // Payments
      if (data.payments && Array.isArray(data.payments)) {
        println(lines, "Reglements:");
        data.payments.forEach((payment) => {
          const { payment_method: methode, amount, rendu } = payment;
          println(lines, formatLine(methode, `${amount.toFixed(3)}`));
          if (rendu > 0)
            println(lines, formatLine("Rendu", `${rendu.toFixed(3)}`));
        });
      } else {
        println(lines, "Aucun payment");
      }

      // Footer
      lines.push(ESC_POS_COMMANDS.CENTER);
      println(lines, "Merci de votre visite !");
      println(lines, "\n\n\n");
      lines.push(ESC_POS_COMMANDS.CUT_PAPER);

      return lines.join("");
    }

    case "cloture": {
      const lines = [];
      lines.push(ESC_POS_COMMANDS.CENTER);
      println(lines, " CLOTURE DE CAISSE ");
      lines.push(ESC_POS_COMMANDS.NORMAL_TEXT);

      addSeparator(lines);

      if (data.code) println(lines, `Code: ${data.code}`);
      else if (data.id)
        println(lines, `Ref: ${data.id.substring(0, 8).toUpperCase()}`);

      const currentDate = new Date();
      const startDate = data.start_date
        ? new Date(data.start_date)
        : currentDate;
      const endDate = data.end_date ? new Date(data.end_date) : currentDate;

      println(
        lines,
        `Ouverture: ${formadate(startDate)} ${formatTime({ date: startDate })}`,
      );
      println(
        lines,
        `Cloture: ${formadate(endDate)} ${formatTime({ date: endDate })}`,
      );

      addSeparator(lines);

      lines.push(ESC_POS_COMMANDS.CENTER);
      println(lines, "RECAPITULATIF FINANCIER");
      lines.push(ESC_POS_COMMANDS.LEFT_ALIGN);

      if (data.fond_initial !== undefined)
        println(
          lines,
          `Fond initial: ${parseFloat(data.fond_initial).toFixed(3)} TND`,
        );

      if (data.fond_final !== undefined) {
        lines.push(ESC_POS_COMMANDS.BOLD_ON);
        println(
          lines,
          `Fond final: ${parseFloat(data.fond_final).toFixed(3)} TND`,
        );
        lines.push(ESC_POS_COMMANDS.BOLD_OFF);
      }

      if (data.fond_initial !== undefined && data.fond_final !== undefined) {
        const difference =
          parseFloat(data.fond_final) - parseFloat(data.fond_initial);
        println(lines, `Différence: ${difference.toFixed(3)} TND`);
        if (difference > 0)
          println(lines, `(Surplus: +${difference.toFixed(3)} TND)`);
        else if (difference < 0)
          println(lines, `(Manquant: ${difference.toFixed(3)} TND)`);
        else println(lines, `(Équilibré)`);
      }

      addSeparator(lines);

      lines.push(ESC_POS_COMMANDS.CENTER);
      println(lines, "*** CLOTURE VALIDEE ***");
      println(lines, "Document comptable à conserver");
      println(lines, "pendant 10 ans");

      return lines.join("");
    }

    case "addition": {
      const lines = [];
      const LINE_WIDTH = 48;

      const padRight = (text, width) =>
        text.length >= width
          ? text.slice(0, width)
          : text + " ".repeat(width - text.length);
      const padLeft = (text, width) =>
        text.length >= width
          ? text.slice(0, width)
          : " ".repeat(width - text.length) + text;
      const formatLine = (left, right) =>
        padRight(left, LINE_WIDTH - right.length) + right;

      lines.push(ESC_POS_COMMANDS.CENTER);
      lines.push(ESC_POS_COMMANDS.BOLD_ON);
      println(lines, restaurant.nom);
      println(lines, restaurant.address);
      println(lines, `Tel: ${restaurant.numero}`);
      lines.push(ESC_POS_COMMANDS.BOLD_OFF);

      lines.push(ESC_POS_COMMANDS.LEFT_ALIGN);
      println(
        lines,
        `Table: ${data.table.table_number === "0" ? "Comptoir" : data.table.table_number} Date: ${formadate(
          data.session.start_time,
        )} ${formatTime({ date: data.session.start_time })}`,
      );
      console.log("data.session", data.session);
      if (data.session?.caissier_id?.nom && data.session?.serveur_id?.nom) {
        println(
          lines,
          `Caissier: ${data.session.caissier_id.nom}  Serveur: ${data.session.serveur_id.nom}`,
        );
      } else if (data.session?.caissier_id?.nom) {
        println(lines, `Caissier: ${data.session.caissier_id.nom}`);
      } else {
        println(lines, `Serveur: ${data.session?.serveur_id?.nom}`);
      }

      addSeparator(lines);

      if (data.items && Array.isArray(data.items)) {
        data.items.forEach((produit) => {
          const name = produit.productInfo?.titre?.fr || "Produit sans nom";
          const qty = produit.quantity || 1;
          const price = produit.price || 0;
          const total = (qty * price).toFixed(3);

          println(lines, padRight(name, LINE_WIDTH));
          println(
            lines,
            formatLine(`  ${qty} x ${price.toFixed(3)}`, `${total}`),
          );
          if (produit.ingredients?.length > 0) {
            produit.ingredients.forEach((ingredient) => {
              // println(lines, `  + ${ingredient.titre || "Ingrédient"}`);
              println(
                lines,
                formatLine(
                  `  + ${ingredient.titre || "Ingrédient"}`,
                  `   ${ingredient?.prix?.toFixed(3) || ""}`,
                ),
              );
            });
          }
        });
      } else {
        println(lines, "Aucun produit");
      }
      if (data.timbre > 0)
        println(
          lines,
          formatLine("Timbre", `${parseFloat(data.timbre).toFixed(3)}`),
        );
      lines.push(ESC_POS_COMMANDS.BOLD_ON);
      println(
        lines,
        formatLine(
          "TOTAL A PAYER",
          `${parseFloat(data.session.total_amount).toFixed(3)}`,
        ),
      );
      lines.push(ESC_POS_COMMANDS.BOLD_OFF);

      lines.push(ESC_POS_COMMANDS.CENTER);
      println(lines, "Merci de votre visite !");
      println(lines, "\n\n\n");
      lines.push(ESC_POS_COMMANDS.CUT_PAPER);

      return lines.join("");
    }

    default:
      return [];
  }
};
